import {createFeatureSelector, createSelector} from '@ngrx/store';
import {FeatureStoreNames} from '@shared-types';

import {formGroupAdapter, FormGroupStore} from './form-group.models';

import IFormGroupsState = FormGroupStore.IFormGroupsState;

export const selectGroupsState = createFeatureSelector<IFormGroupsState>(FeatureStoreNames.FORM_GROUP_FEATURE_KEY);
const {selectAll, selectEntities} = formGroupAdapter.getSelectors();

export const selectAllFormGroup = createSelector(selectGroupsState, (state: IFormGroupsState) => selectAll(state));

export const selectFormGroupEntities = createSelector(selectGroupsState, (state: IFormGroupsState) => selectEntities(state));

export const selectFormGroupLoaded = createSelector(selectGroupsState, (state: IFormGroupsState) => state.loaded);

export const selectFormGroupLoading = createSelector(selectGroupsState, (state: IFormGroupsState) => state.loading);
